(()=>{
    var e = Object.defineProperty
      , t = (t,i,n)=>(((t,i,n)=>{
        i in t ? e(t, i, {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: n
        }) : t[i] = n
    }
    )(t, "symbol" != typeof i ? i + "" : i, n),
    n);
    function i(e) {
        this.listenerMap = [{}, {}],
        e && this.root(e),
        this.handle = i.prototype.handle.bind(this),
        this._removedListeners = []
    }
    function n(e, t) {
        return e.toLowerCase() === t.tagName.toLowerCase()
    }
    function s(e, t) {
        return this.rootElement === window ? t === document || t === document.documentElement || t === window : this.rootElement === t
    }
    function a(e, t) {
        return e === t.id
    }
    i.prototype.root = function(e) {
        const t = this.listenerMap;
        let i;
        if (this.rootElement) {
            for (i in t[1])
                t[1].hasOwnProperty(i) && this.rootElement.removeEventListener(i, this.handle, !0);
            for (i in t[0])
                t[0].hasOwnProperty(i) && this.rootElement.removeEventListener(i, this.handle, !1)
        }
        if (!e || !e.addEventListener)
            return this.rootElement && delete this.rootElement,
            this;
        for (i in this.rootElement = e,
        t[1])
            t[1].hasOwnProperty(i) && this.rootElement.addEventListener(i, this.handle, !0);
        for (i in t[0])
            t[0].hasOwnProperty(i) && this.rootElement.addEventListener(i, this.handle, !1);
        return this
    }
    ,
    i.prototype.captureForType = function(e) {
        return -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e)
    }
    ,
    i.prototype.on = function(e, t, i, r) {
        let o, l, c, d;
        if (!e)
            throw new TypeError("Invalid event type: " + e);
        if ("function" == typeof t && (r = i,
        i = t,
        t = null),
        void 0 === r && (r = this.captureForType(e)),
        "function" != typeof i)
            throw new TypeError("Handler must be a type of Function");
        return o = this.rootElement,
        l = this.listenerMap[r ? 1 : 0],
        l[e] || (o && o.addEventListener(e, this.handle, r),
        l[e] = []),
        t ? /^[a-z]+$/i.test(t) ? (d = t,
        c = n) : /^#[a-z0-9\-_]+$/i.test(t) ? (d = t.slice(1),
        c = a) : (d = t,
        c = Element.prototype.matches) : (d = null,
        c = s.bind(this)),
        l[e].push({
            selector: t,
            handler: i,
            matcher: c,
            matcherParam: d
        }),
        this
    }
    ,
    i.prototype.off = function(e, t, i, n) {
        let s, a, r, o, l;
        if ("function" == typeof t && (n = i,
        i = t,
        t = null),
        void 0 === n)
            return this.off(e, t, i, !0),
            this.off(e, t, i, !1),
            this;
        if (r = this.listenerMap[n ? 1 : 0],
        !e) {
            for (l in r)
                r.hasOwnProperty(l) && this.off(l, t, i);
            return this
        }
        if (o = r[e],
        !o || !o.length)
            return this;
        for (s = o.length - 1; s >= 0; s--)
            a = o[s],
            t && t !== a.selector || i && i !== a.handler || (this._removedListeners.push(a),
            o.splice(s, 1));
        return o.length || (delete r[e],
        this.rootElement && this.rootElement.removeEventListener(e, this.handle, n)),
        this
    }
    ,
    i.prototype.handle = function(e) {
        let t, i;
        const n = e.type;
        let s, a, r, o, l, c = [];
        const d = "ftLabsDelegateIgnore";
        if (!0 === e[d])
            return;
        switch (l = e.target,
        3 === l.nodeType && (l = l.parentNode),
        l.correspondingUseElement && (l = l.correspondingUseElement),
        s = this.rootElement,
        a = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2),
        a) {
        case 1:
            c = this.listenerMap[1][n];
            break;
        case 2:
            this.listenerMap[0] && this.listenerMap[0][n] && (c = c.concat(this.listenerMap[0][n])),
            this.listenerMap[1] && this.listenerMap[1][n] && (c = c.concat(this.listenerMap[1][n]));
            break;
        case 3:
            c = this.listenerMap[0][n]
        }
        let h, u = [];
        for (i = c.length; l && i; ) {
            for (t = 0; t < i && (r = c[t],
            r); t++)
                l.tagName && ["button", "input", "select", "textarea"].indexOf(l.tagName.toLowerCase()) > -1 && l.hasAttribute("disabled") ? u = [] : r.matcher.call(l, r.matcherParam, l) && u.push([e, l, r]);
            if (l === s)
                break;
            if (i = c.length,
            l = l.parentElement || l.parentNode,
            l instanceof HTMLDocument)
                break
        }
        for (t = 0; t < u.length; t++)
            if (!(this._removedListeners.indexOf(u[t][2]) > -1) && (o = this.fire.apply(this, u[t]),
            !1 === o)) {
                u[t][0][d] = !0,
                u[t][0].preventDefault(),
                h = !1;
                break
            }
        return h
    }
    ,
    i.prototype.fire = function(e, t, i) {
        return i.handler.call(t, e, t)
    }
    ,
    i.prototype.destroy = function() {
        this.off(),
        this.root()
    }
    ;
    var r = i
      ,
      
      o = class {
        constructor() {
            this.delegateElement = new r(document.body),
            this.delegateElement.on("change", "[data-bind-value]", this._onValueChanged.bind(this))
        }
        _onValueChanged(e, t) {
            const i = document.getElementById(t.getAttribute("data-bind-value"));
            i && ("SELECT" === t.tagName && (t = t.options[t.selectedIndex]),
            i.innerHTML = t.hasAttribute("title") ? t.getAttribute("title") : t.value)
        }
    }
    ;
    function l(e, t, i={}) {
        e.dispatchEvent(new CustomEvent(t,{
            bubbles: !0,
            detail: i
        }))
    }
    function c(e, t, i={}) {
        e.dispatchEvent(new CustomEvent(t,{
            bubbles: !1,
            detail: i
        }))
    }
    var d = class extends HTMLElement {
        constructor() {
            super(),
            this._hasSectionReloaded = !1,
            Shopify.designMode && this.rootDelegate.on("shopify:section:select", (e=>{
                const t = this.closest(".shopify-section");
                e.target === t && e.detail.load && (this._hasSectionReloaded = !0)
            }
            ))
        }
        get rootDelegate() {
            return this._rootDelegate = this._rootDelegate || new r(document.documentElement)
        }
        get delegate() {
            return this._delegate = this._delegate || new r(this)
        }
        showLoadingBar() {
            l(document.documentElement, "theme:loading:start")
        }
        hideLoadingBar() {
            l(document.documentElement, "theme:loading:end")
        }
        untilVisible(e={
            rootMargin: "0px",
            threshold: .2
        }) {
            const t = ()=>{
                this.classList.add("became-visible"),
                this.style.opacity = "1"
            }
            ;
            return new Promise((i=>{
                window.IntersectionObserver ? (this.intersectionObserver = new IntersectionObserver((e=>{
                    e[0].isIntersecting && (this.intersectionObserver.disconnect(),
                    requestAnimationFrame((()=>{
                        i(),
                        t()
                    }
                    )))
                }
                ),e),
                this.intersectionObserver.observe(this)) : (i(),
                t())
            }
            ))
        }
        disconnectedCallback() {
            var e;
            this.delegate.destroy(),
            this.rootDelegate.destroy(),
            null == (e = this.intersectionObserver) || e.disconnect(),
            delete this._delegate,
            delete this._rootDelegate
        }
    }
      , h = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"]
      , u = h.join(",")
      , p = "undefined" == typeof Element ? function() {}
    : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
      , m = function(e) {
        var t = parseInt(e.getAttribute("tabindex"), 10);
        return isNaN(t) ? function(e) {
            return "true" === e.contentEditable
        }(e) ? 0 : "AUDIO" !== e.nodeName && "VIDEO" !== e.nodeName && "DETAILS" !== e.nodeName || null !== e.getAttribute("tabindex") ? e.tabIndex : 0 : t
    }
      , b = function(e, t) {
        return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex
    }
      , g = function(e) {
        return "INPUT" === e.tagName
    }
      , f = function(e) {
        return function(e) {
            return g(e) && "radio" === e.type
        }(e) && !function(e) {
            if (!e.name)
                return !0;
            var t, i = e.form || e.ownerDocument, n = function(e) {
                return i.querySelectorAll('input[type="radio"][name="' + e + '"]')
            };
            if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape)
                t = n(window.CSS.escape(e.name));
            else
                try {
                    t = n(e.name)
                } catch (e) {
                    return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message),
                    !1
                }
            var s = function(e, t) {
                for (var i = 0; i < e.length; i++)
                    if (e[i].checked && e[i].form === t)
                        return e[i]
            }(t, e.form);
            return !s || s === e
        }(e)
    }
      , w = function(e, t) {
        return !(t.disabled || function(e) {
            return g(e) && "hidden" === e.type
        }(t) || function(e, t) {
            if ("hidden" === getComputedStyle(e).visibility)
                return !0;
            var i = p.call(e, "details>summary:first-of-type") ? e.parentElement : e;
            if (p.call(i, "details:not([open]) *"))
                return !0;
            if (t && "full" !== t) {
                if ("non-zero-area" === t) {
                    var n = e.getBoundingClientRect()
                      , s = n.width
                      , a = n.height;
                    return 0 === s && 0 === a
                }
            } else
                for (; e; ) {
                    if ("none" === getComputedStyle(e).display)
                        return !0;
                    e = e.parentElement
                }
            return !1
        }(t, e.displayCheck) || function(e) {
            return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some((function(e) {
                return "SUMMARY" === e.tagName
            }
            ))
        }(t) || function(e) {
            if (g(e) || "SELECT" === e.tagName || "TEXTAREA" === e.tagName || "BUTTON" === e.tagName)
                for (var t = e.parentElement; t; ) {
                    if ("FIELDSET" === t.tagName && t.disabled) {
                        for (var i = 0; i < t.children.length; i++) {
                            var n = t.children.item(i);
                            if ("LEGEND" === n.tagName)
                                return !n.contains(e)
                        }
                        return !0
                    }
                    t = t.parentElement
                }
            return !1
        }(t))
    }
      , y = function(e, t) {
        return !(!w(e, t) || f(t) || m(t) < 0)
    }
      , v = function(e, t) {
        var i = []
          , n = []
          , s = function(e, t, i) {
            var n = Array.prototype.slice.apply(e.querySelectorAll(u));
            return t && p.call(e, u) && n.unshift(e),
            n.filter(i)
        }(e, (t = t || {}).includeContainer, y.bind(null, t));
        return s.forEach((function(e, t) {
            var s = m(e);
            0 === s ? i.push(e) : n.push({
                documentOrder: t,
                tabIndex: s,
                node: e
            })
        }
        )),
        n.sort(b).map((function(e) {
            return e.node
        }
        )).concat(i)
    }
      , _ = h.concat("iframe").join(",")
      , E = function(e, t) {
        if (t = t || {},
        !e)
            throw new Error("No node provided");
        return !1 !== p.call(e, _) && w(t, e)
    };
    function x(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            t && (n = n.filter((function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable
            }
            ))),
            i.push.apply(i, n)
        }
        return i
    }
    function S(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i,
        e
    }
    var L, A = (L = [],
    {
        activateTrap: function(e) {
            if (L.length > 0) {
                var t = L[L.length - 1];
                t !== e && t.pause()
            }
            var i = L.indexOf(e);
            -1 === i || L.splice(i, 1),
            L.push(e)
        },
        deactivateTrap: function(e) {
            var t = L.indexOf(e);
            -1 !== t && L.splice(t, 1),
            L.length > 0 && L[L.length - 1].unpause()
        }
    }), k = function(e) {
        return setTimeout(e, 0)
    }, C = function(e, t) {
        var i = -1;
        return e.every((function(e, n) {
            return !t(e) || (i = n,
            !1)
        }
        )),
        i
    }, I = function(e) {
        for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
            i[n - 1] = arguments[n];
        return "function" == typeof e ? e.apply(void 0, i) : e
    }, T = function(e) {
        return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target
    }, P = function(e, t) {
        var i, n = (null == t ? void 0 : t.document) || document, s = function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var i = null != arguments[t] ? arguments[t] : {};
                t % 2 ? x(Object(i), !0).forEach((function(t) {
                    S(e, t, i[t])
                }
                )) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : x(Object(i)).forEach((function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t))
                }
                ))
            }
            return e
        }({
            returnFocusOnDeactivate: !0,
            escapeDeactivates: !0,
            delayInitialFocus: !0
        }, t), a = {
            containers: [],
            tabbableGroups: [],
            nodeFocusedBeforeActivation: null,
            mostRecentlyFocusedNode: null,
            active: !1,
            paused: !1,
            delayInitialFocusTimer: void 0
        }, r = function(e, t, i) {
            return e && void 0 !== e[t] ? e[t] : s[i || t]
        }, o = function(e) {
            return !(!e || !a.containers.some((function(t) {
                return t.contains(e)
            }
            )))
        }, l = function(e) {
            var t = s[e];
            if ("function" == typeof t) {
                for (var i = arguments.length, a = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++)
                    a[r - 1] = arguments[r];
                t = t.apply(void 0, a)
            }
            if (!t) {
                if (void 0 === t || !1 === t)
                    return t;
                throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node"))
            }
            var o = t;
            if ("string" == typeof t && !(o = n.querySelector(t)))
                throw new Error("`".concat(e, "` as selector refers to no known node"));
            return o
        }, c = function() {
            var e = l("initialFocus");
            if (!1 === e)
                return !1;
            if (void 0 === e)
                if (o(n.activeElement))
                    e = n.activeElement;
                else {
                    var t = a.tabbableGroups[0];
                    e = t && t.firstTabbableNode || l("fallbackFocus")
                }
            if (!e)
                throw new Error("Your focus-trap needs to have at least one focusable element");
            return e
        }, d = function() {
            if (a.tabbableGroups = a.containers.map((function(e) {
                var t = v(e);
                if (t.length > 0)
                    return {
                        container: e,
                        firstTabbableNode: t[0],
                        lastTabbableNode: t[t.length - 1]
                    }
            }
            )).filter((function(e) {
                return !!e
            }
            )),
            a.tabbableGroups.length <= 0 && !l("fallbackFocus"))
                throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times")
        }, h = function e(t) {
            !1 !== t && t !== n.activeElement && (t && t.focus ? (t.focus({
                preventScroll: !!s.preventScroll
            }),
            a.mostRecentlyFocusedNode = t,
            function(e) {
                return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select
            }(t) && t.select()) : e(c()))
        }, u = function(e) {
            var t = l("setReturnFocus", e);
            return t || !1 !== t && e
        }, p = function(e) {
            var t = T(e);
            o(t) || (I(s.clickOutsideDeactivates, e) ? i.deactivate({
                returnFocus: s.returnFocusOnDeactivate && !E(t)
            }) : I(s.allowOutsideClick, e) || e.preventDefault())
        }, m = function(e) {
            var t = T(e)
              , i = o(t);
            i || t instanceof Document ? i && (a.mostRecentlyFocusedNode = t) : (e.stopImmediatePropagation(),
            h(a.mostRecentlyFocusedNode || c()))
        }, b = function(e) {
            if (function(e) {
                return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode
            }(e) && !1 !== I(s.escapeDeactivates, e))
                return e.preventDefault(),
                void i.deactivate();
            (function(e) {
                return "Tab" === e.key || 9 === e.keyCode
            }
            )(e) && function(e) {
                var t = T(e);
                d();
                var i = null;
                if (a.tabbableGroups.length > 0) {
                    var n = C(a.tabbableGroups, (function(e) {
                        return e.container.contains(t)
                    }
                    ));
                    if (n < 0)
                        i = e.shiftKey ? a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : a.tabbableGroups[0].firstTabbableNode;
                    else if (e.shiftKey) {
                        var s = C(a.tabbableGroups, (function(e) {
                            var i = e.firstTabbableNode;
                            return t === i
                        }
                        ));
                        if (s < 0 && a.tabbableGroups[n].container === t && (s = n),
                        s >= 0) {
                            var r = 0 === s ? a.tabbableGroups.length - 1 : s - 1;
                            i = a.tabbableGroups[r].lastTabbableNode
                        }
                    } else {
                        var o = C(a.tabbableGroups, (function(e) {
                            var i = e.lastTabbableNode;
                            return t === i
                        }
                        ));
                        if (o < 0 && a.tabbableGroups[n].container === t && (o = n),
                        o >= 0) {
                            var c = o === a.tabbableGroups.length - 1 ? 0 : o + 1;
                            i = a.tabbableGroups[c].firstTabbableNode
                        }
                    }
                } else
                    i = l("fallbackFocus");
                i && (e.preventDefault(),
                h(i))
            }(e)
        }, g = function(e) {
            if (!I(s.clickOutsideDeactivates, e)) {
                var t = T(e);
                o(t) || I(s.allowOutsideClick, e) || (e.preventDefault(),
                e.stopImmediatePropagation())
            }
        }, f = function() {
            if (a.active)
                return A.activateTrap(i),
                a.delayInitialFocusTimer = s.delayInitialFocus ? k((function() {
                    h(c())
                }
                )) : h(c()),
                n.addEventListener("focusin", m, !0),
                n.addEventListener("mousedown", p, {
                    capture: !0,
                    passive: !1
                }),
                n.addEventListener("touchstart", p, {
                    capture: !0,
                    passive: !1
                }),
                n.addEventListener("click", g, {
                    capture: !0,
                    passive: !1
                }),
                n.addEventListener("keydown", b, {
                    capture: !0,
                    passive: !1
                }),
                i
        }, w = function() {
            if (a.active)
                return n.removeEventListener("focusin", m, !0),
                n.removeEventListener("mousedown", p, !0),
                n.removeEventListener("touchstart", p, !0),
                n.removeEventListener("click", g, !0),
                n.removeEventListener("keydown", b, !0),
                i
        };
        return (i = {
            activate: function(e) {
                if (a.active)
                    return this;
                var t = r(e, "onActivate")
                  , i = r(e, "onPostActivate")
                  , s = r(e, "checkCanFocusTrap");
                s || d(),
                a.active = !0,
                a.paused = !1,
                a.nodeFocusedBeforeActivation = n.activeElement,
                t && t();
                var o = function() {
                    s && d(),
                    f(),
                    i && i()
                };
                return s ? (s(a.containers.concat()).then(o, o),
                this) : (o(),
                this)
            },
            deactivate: function(e) {
                if (!a.active)
                    return this;
                clearTimeout(a.delayInitialFocusTimer),
                a.delayInitialFocusTimer = void 0,
                w(),
                a.active = !1,
                a.paused = !1,
                A.deactivateTrap(i);
                var t = r(e, "onDeactivate")
                  , n = r(e, "onPostDeactivate")
                  , s = r(e, "checkCanReturnFocus");
                t && t();
                var o = r(e, "returnFocus", "returnFocusOnDeactivate")
                  , l = function() {
                    k((function() {
                        o && h(u(a.nodeFocusedBeforeActivation)),
                        n && n()
                    }
                    ))
                };
                return o && s ? (s(u(a.nodeFocusedBeforeActivation)).then(l, l),
                this) : (l(),
                this)
            },
            pause: function() {
                return a.paused || !a.active || (a.paused = !0,
                w()),
                this
            },
            unpause: function() {
                return a.paused && a.active ? (a.paused = !1,
                d(),
                f(),
                this) : this
            },
            updateContainerElements: function(e) {
                var t = [].concat(e).filter(Boolean);
                return a.containers = t.map((function(e) {
                    return "string" == typeof e ? n.querySelector(e) : e
                }
                )),
                a.active && d(),
                this
            }
        }).updateContainerElements(e),
        i
    };
    function M(e, t, i) {
        let n = !1;
        e.type.includes("shopify:section") ? t.hasAttribute("section") && t.getAttribute("section") === e.detail.sectionId && (n = !0) : e.type.includes("shopify:block") && e.target === t && (n = !0),
        n && i(e)
    }
    var q = class extends d {
        static get observedAttributes() {
            return ["open"]
        }
        constructor() {
            if (super(),
            Shopify.designMode && (this.rootDelegate.on("shopify:section:select", (e=>M(e, this, (()=>this.open = !0)))),
            this.rootDelegate.on("shopify:section:deselect", (e=>M(e, this, (()=>this.open = !1))))),
            this.hasAttribute("append-body")) {
                const e = document.getElementById(this.id);
                this.removeAttribute("append-body"),
                e && e !== this ? (e.replaceWith(this.cloneNode(!0)),
                this.remove()) : document.body.appendChild(this)
            }
        }
        connectedCallback() {
            this.delegate.on("click", ".openable__overlay", (()=>this.open = !1)),
            this.delegate.on("click", '[data-action="close"]', (e=>{
                e.stopPropagation(),
                this.open = !1
            }
            ))
        }
        get requiresLoading() {
            return this.hasAttribute("href")
        }
        get open() {
            return this.hasAttribute("open")
        }
        set open(e) {
            e ? (async()=>{
                await this._load(),
                this.clientWidth,
                this.setAttribute("open", "")
            }
            )() : this.removeAttribute("open")
        }
        get shouldTrapFocus() {
            return !0
        }
        get returnFocusOnDeactivate() {
            return !this.hasAttribute("return-focus") || "true" === this.getAttribute("return-focus")
        }
        get focusTrap() {
            return this._focusTrap = this._focusTrap || P(this, {
                fallbackFocus: this,
                initialFocus: this.hasAttribute("initial-focus-selector") ? this.getAttribute("initial-focus-selector") : void 0,
                clickOutsideDeactivates: e=>!(e.target.hasAttribute("aria-controls") && e.target.getAttribute("aria-controls") === this.id),
                allowOutsideClick: e=>e.target.hasAttribute("aria-controls") && e.target.getAttribute("aria-controls") === this.id,
                returnFocusOnDeactivate: this.returnFocusOnDeactivate,
                onDeactivate: ()=>this.open = !1,
                preventScroll: !0
            })
        }
        attributeChangedCallback(e, t, i) {
            if ("open" === e)
                null === t && "" === i ? (this.shouldTrapFocus && setTimeout((()=>this.focusTrap.activate()), 150),
                l(this, "openable-element:open")) : null === i && (this.shouldTrapFocus && this.focusTrap.deactivate(),
                l(this, "openable-element:close"))
        }
        async _load() {
            if (!this.requiresLoading)
                return;
            c(this, "openable-element:load:start");
            const e = await fetch(this.getAttribute("href"))
              , t = document.createElement("div");
            t.innerHTML = await e.text(),
            this.innerHTML = t.querySelector(this.tagName.toLowerCase()).innerHTML,
            this.removeAttribute("href"),
            c(this, "openable-element:load:end")
        }
    }
    ;
    window.customElements.define("openable-element", q);
    var B = {
        _prepareButton() {
            this.originalContent = this.innerHTML,
            this._startTransitionPromise = null,
            this.innerHTML = `\n      <span class="loader-button__text">${this.innerHTML}</span>\n      <span class="loader-button__loader" hidden>\n        <div class="spinner">\n          <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">\n            <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>\n          </svg>\n        </div>\n      </span>\n    `,
            this.textElement = this.firstElementChild,
            this.spinnerElement = this.lastElementChild,
            window.addEventListener("pagehide", (()=>this.removeAttribute("aria-busy")))
        },
        _startTransition() {
            const e = this.textElement.animate({
                opacity: [1, 0],
                transform: ["translateY(0)", "translateY(-10px)"]
            }, {
                duration: 75,
                easing: "ease",
                fill: "forwards"
            });
            this.spinnerElement.hidden = !1;
            const t = this.spinnerElement.animate({
                opacity: [0, 1],
                transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
            }, {
                duration: 75,
                delay: 75,
                easing: "ease",
                fill: "forwards"
            });
            this._startTransitionPromise = Promise.all([new Promise((t=>e.onfinish = ()=>t())), new Promise((e=>t.onfinish = ()=>e()))])
        },
        async _endTransition() {
            this._startTransitionPromise && (await this._startTransitionPromise,
            this.spinnerElement.animate({
                opacity: [1, 0],
                transform: ["translate(-50%, -50%)", "translate(-50%, -100%)"]
            }, {
                duration: 75,
                delay: 100,
                easing: "ease",
                fill: "forwards"
            }).onfinish = ()=>this.spinnerElement.hidden = !0,
            this.textElement.animate({
                opacity: [0, 1],
                transform: ["translateY(10px)", "translateY(0)"]
            }, {
                duration: 75,
                delay: 175,
                easing: "ease",
                fill: "forwards"
            }),
            this._startTransitionPromise = null)
        }
    }
      , O = class extends HTMLButtonElement {
        static get observedAttributes() {
            return ["aria-busy"]
        }
        constructor() {
            super(),
            this.addEventListener("click", (e=>{
                "submit" === this.type && this.form && this.form.checkValidity() && !this.form.hasAttribute("is") && (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? (e.preventDefault(),
                this.setAttribute("aria-busy", "true"),
                setTimeout((()=>this.form.submit()), 250)) : this.setAttribute("aria-busy", "true"))
            }
            ))
        }
        connectedCallback() {
            this._prepareButton()
        }
        disconnectedCallback() {
            this.innerHTML = this.originalContent
        }
        attributeChangedCallback(e, t, i) {
            "aria-busy" === e && ("true" === i ? this._startTransition() : this._endTransition())
        }
    }
    ;
    Object.assign(O.prototype, B),
    window.customElements.define("loader-button", O, {
        extends: "button"
    });
    window.customElements.define("page-pagination", class extends d {
        connectedCallback() {
            this.hasAttribute("ajax") && this.delegate.on("click", "a", this._onLinkClicked.bind(this))
        }
        _onLinkClicked(e, t) {
            e.preventDefault();
            const i = new URL(window.location.href);
            i.searchParams.set("page", t.getAttribute("data-page")),
            l(this, "pagination:page-changed", {
                url: i.toString()
            })
        }
    }
    );
    var H = class extends HTMLButtonElement {
        static get observedAttributes() {
            return ["aria-expanded", "aria-busy"]
        }
        constructor() {
            super(),
            this.hasAttribute("loader") && this._prepareButton(),
            this.addEventListener("click", this._onButtonClick.bind(this)),
            this.rootDelegate = new r(document.documentElement)
        }
        _onButtonClick() {
            this.isExpanded = !this.isExpanded
        }
        connectedCallback() {
            document.addEventListener("openable-element:close", (e=>{
                this.controlledElement === e.target && (this.isExpanded = !1,
                e.stopPropagation())
            }
            )),
            document.addEventListener("openable-element:open", (e=>{
                this.controlledElement === e.target && (this.isExpanded = !0,
                e.stopPropagation())
            }
            )),
            this.rootDelegate.on("openable-element:load:start", `#${this.getAttribute("aria-controls")}`, (()=>{
                this.classList.contains("button") ? this.setAttribute("aria-busy", "true") : null !== this.offsetParent && l(document.documentElement, "theme:loading:start")
            }
            ), !0),
            this.rootDelegate.on("openable-element:load:end", `#${this.getAttribute("aria-controls")}`, (()=>{
                this.classList.contains("button") ? this.removeAttribute("aria-busy") : null !== this.offsetParent && l(document.documentElement, "theme:loading:end")
            }
            ), !0)
        }
        disconnectedCallback() {
            this.rootDelegate.destroy()
        }
        get isExpanded() {
            return "true" === this.getAttribute("aria-expanded")
        }
        set isExpanded(e) {
            this.setAttribute("aria-expanded", e ? "true" : "false")
        }
        get controlledElement() {
            return document.getElementById(this.getAttribute("aria-controls"))
        }
        attributeChangedCallback(e, t, i) {
            switch (e) {
            case "aria-expanded":
                "false" === t && "true" === i ? this.controlledElement.open = !0 : "true" === t && "false" === i && (this.controlledElement.open = !1);
                break;
            case "aria-busy":
                this.hasAttribute("loader") && ("true" === i ? this._startTransition() : this._endTransition())
            }
        }
    }
    ;
    Object.assign(H.prototype, B),
    window.customElements.define("toggle-button", H, {
        extends: "button"
    });
    var $ = class extends HTMLAnchorElement {
        static get observedAttributes() {
            return ["aria-expanded"]
        }
        constructor() {
            super(),
            this.addEventListener("click", (e=>{
                e.preventDefault(),
                this.isExpanded = !this.isExpanded
            }
            )),
            this.rootDelegate = new r(document.documentElement)
        }
        connectedCallback() {
            this.rootDelegate.on("openable-element:close", `#${this.getAttribute("aria-controls")}`, (e=>{
                this.controlledElement === e.target && (this.isExpanded = !1)
            }
            ), !0),
            this.rootDelegate.on("openable-element:open", `#${this.getAttribute("aria-controls")}`, (e=>{
                this.controlledElement === e.target && (this.isExpanded = !0)
            }
            ), !0)
        }
        disconnectedCallback() {
            this.rootDelegate.destroy()
        }
        get isExpanded() {
            return "true" === this.getAttribute("aria-expanded")
        }
        set isExpanded(e) {
            this.setAttribute("aria-expanded", e ? "true" : "false")
        }
        get controlledElement() {
            return document.querySelector(`#${this.getAttribute("aria-controls")}`)
        }
        attributeChangedCallback(e, t, i) {
            if ("aria-expanded" === e)
                "false" === t && "true" === i ? this.controlledElement.open = !0 : "true" === t && "false" === i && (this.controlledElement.open = !1)
        }
    }
    ;
    // window.customElements.define("toggle-link", $, {
    //     extends: "a"
    // });
    window.customElements.define("page-dots", class extends d {
        connectedCallback() {
            this.buttons = Array.from(this.querySelectorAll("button")),
            this.delegate.on("click", "button", ((e,t)=>{
                this._dispatchEvent(this.buttons.indexOf(t))
            }
            )),
            this.hasAttribute("animation-timer") && this.delegate.on("animationend", (e=>{
                e.elapsedTime > 0 && this._dispatchEvent((this.selectedIndex + 1 + this.buttons.length) % this.buttons.length)
            }
            ))
        }
        get selectedIndex() {
            return this.buttons.findIndex((e=>"true" === e.getAttribute("aria-current")))
        }
        set selectedIndex(e) {
            if (this.buttons.forEach(((t,i)=>t.setAttribute("aria-current", e === i ? "true" : "false"))),
            this.hasAttribute("align-selected")) {
                const t = this.buttons[e]
                  , i = window.innerWidth / 2
                  , n = t.getBoundingClientRect()
                  , s = this._findFirstScrollableElement(this.parentElement);
                s && s.scrollTo({
                    behavior: "smooth",
                    left: s.scrollLeft + (n.left - i) + n.width / 2
                })
            }
        }
        _dispatchEvent(e) {
            e !== this.selectedIndex && this.dispatchEvent(new CustomEvent("page-dots:changed",{
                bubbles: !0,
                detail: {
                    index: e
                }
            }))
        }
        _findFirstScrollableElement(e, t=0) {
            return null === e || t > 3 ? null : e.scrollWidth > e.clientWidth ? e : this._findFirstScrollableElement(e.parentElement, t + 1)
        }
    }
    );
    var D = class extends HTMLElement {
        connectedCallback() {
            this.prevButton = this.querySelector("button:first-of-type"),
            this.nextButton = this.querySelector("button:last-of-type"),
            this.prevButton.addEventListener("click", (()=>this.prevButton.dispatchEvent(new CustomEvent("prev-next:prev",{
                bubbles: !0
            })))),
            this.nextButton.addEventListener("click", (()=>this.nextButton.dispatchEvent(new CustomEvent("prev-next:next",{
                bubbles: !0
            }))))
        }
        set isPrevDisabled(e) {
            this.prevButton.disabled = e
        }
        set isNextDisabled(e) {
            this.nextButton.disabled = e
        }
    }
      , R = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", (()=>this.dispatchEvent(new CustomEvent("prev-next:prev",{
                bubbles: !0
            }))))
        }
    }
      , N = class extends HTMLButtonElement {
        connectedCallback() {
            this.addEventListener("click", (()=>this.dispatchEvent(new CustomEvent("prev-next:next",{
                bubbles: !0
            }))))
        }
    }
    ;
    function F() {
        const e = getComputedStyle(document.documentElement);
        return parseInt(e.getPropertyValue("--header-height") || 0) * parseInt(e.getPropertyValue("--enable-sticky-header") || 0) + parseInt(e.getPropertyValue("--announcement-bar-height") || 0) * parseInt(e.getPropertyValue("--enable-sticky-announcement-bar") || 0)
    }
    window.customElements.define("prev-next-buttons", D),
    window.customElements.define("prev-button", R, {
        extends: "button"
    }),
    window.customElements.define("next-button", N, {
        extends: "button"
    });
    function W(e, t=15) {
        let i = null
          , n = null;
        const s = a=>{
            n = a;
            !i && (e(n),
            n = null,
            i = setTimeout((()=>{
                i = null,
                n && s(n)
            }
            ), t))
        }
        ;
        return s
    }
    window.customElements.define("native-carousel-item", class extends d {
        static get observedAttributes() {
            return ["hidden"]
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        set selected(e) {
            this.hidden = !e
        }
    }
    ),
    window.customElements.define("native-carousel", class extends d {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll("native-carousel-item")),
            this.pageDotsElements = Array.from(this.querySelectorAll("page-dots")),
            this.prevNextButtonsElements = Array.from(this.querySelectorAll("prev-next-buttons")),
            this.items.length > 1 && (this.addEventListener("prev-next:prev", this.prev.bind(this)),
            this.addEventListener("prev-next:next", this.next.bind(this)),
            this.addEventListener("page-dots:changed", (e=>this.select(e.detail.index, !0))),
            Shopify.designMode && this.addEventListener("shopify:block:select", (e=>this.select(e.target.index, !e.detail.load))));
            const e = this.items[0].parentElement;
            this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this),{
                root: e,
                rootMargin: `${e.clientHeight}px 0px`,
                threshold: .8
            }),
            this.items.forEach((e=>this.intersectionObserver.observe(e)))
        }
        disconnectedCallback() {
            super.disconnectedCallback(),
            this.intersectionObserver.disconnect()
        }
        get selectedIndex() {
            return this.items.findIndex((e=>e.selected))
        }
        prev(e=!0) {
            this.select(Math.max(this.selectedIndex - 1, 0), e)
        }
        next(e=!0) {
            this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), e)
        }
        select(e, t=!0) {
            const i = Math.max(0, Math.min(e, this.items.length))
              , n = this.items[i];
            this._adjustNavigationForElement(n),
            t && (this.items.forEach((e=>this.intersectionObserver.unobserve(e))),
            setInterval((()=>{
                this.items.forEach((e=>this.intersectionObserver.observe(e)))
            }
            ), 800)),
            this.items.forEach(((e,t)=>e.selected = t === i));
            const s =  1 ;
            n.parentElement.scrollTo({
                left: s * (n.clientWidth * i),
                behavior: t ? "smooth" : "auto"
            })
        }
        _adjustNavigationForElement(e) {
            this.items.forEach((t=>t.selected = e === t)),
            this.pageDotsElements.forEach((t=>t.selectedIndex = e.index)),
            this.prevNextButtonsElements.forEach((t=>{
                t.isPrevDisabled = 0 === e.index,
                t.isNextDisabled = e.index === this.items.length - 1
            }
            ))
        }
        _onVisibilityChanged(e) {
            for (let t of e)
                if (t.isIntersecting) {
                    this._adjustNavigationForElement(t.target);
                    break
                }
        }
    }
    );
    var ne = class {
        static prefersReducedMotion() {
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches
        }
        static supportsHover() {
            return window.matchMedia("(pointer: fine)").matches
        }
    }
    ;
    function se(e, t, i=!1) {
        let n = []
          , s = e;
        for (; s = s.previousElementSibling; )
            t && !s.matches(t) || n.push(s);
        for (i && n.push(e),
        s = e; s = s.nextElementSibling; )
            t && !s.matches(t) || n.push(s);
        return n
    }
    async function ae(e) {
        const t = [];
        null != e && "function" == typeof e[Symbol.iterator] || (e = [e]);
        for (const i of e)
            if ("function" == typeof i[Symbol.asyncIterator])
                for await(const e of i)
                    t.push(e);
            else
                t.push(i);
        return t
    }

    ;
    var oe = class extends HTMLElement {
        constructor() {
            super(),
            this.hasLoaded = !1,
            this.autoPlay ? this.play() : this.addEventListener("click", this.play.bind(this), {
                once: !0
            })
        }
        get autoPlay() {
            return this.hasAttribute("autoplay")
        }
        play() {
            this.hasLoaded || this._replaceContent(),
            this.querySelector("video").play()
        }
        pause() {
            this.hasLoaded && this.querySelector("video").pause()
        }
        _replaceContent() {
            const e = this.querySelector("template").content.firstElementChild.cloneNode(!0);
            this.innerHTML = "",
            this.appendChild(e),
            this.firstElementChild.addEventListener("play", (()=>{
                this.dispatchEvent(new CustomEvent("video:played",{
                    bubbles: !0
                }))
            }
            )),
            this.firstElementChild.addEventListener("pause", (()=>{
                this.dispatchEvent(new CustomEvent("video:paused",{
                    bubbles: !0
                }))
            }
            )),
            this.hasLoaded = !0
        }
    }
    ;
    function ue(e, t) {
        let i = "string" == typeof e ? e : e.preview_image ? e.preview_image.src : e.url;
        if (null === t)
            return i;
        if ("master" === t)
            return i.replace(/http(s)?:/, "");
        const n = i.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (n) {
            const e = i.split(n[0])
              , s = n[0];
            return (e[0] + "_" + t + s).replace(/http(s)?:/, "")
        }
        return null
    }
    function pe(e, t) {
        let i = [];
        return ("string" == typeof e ? t : me(e, t)).forEach((t=>{
            i.push(`${ue(e, t + "x")} ${t}w`)
        }
        )),
        i.join(",")
    }
    function me(e, t) {
        let i = []
          , n = e.preview_image.width;
        return t.forEach((e=>{
            n >= e && i.push(e)
        }
        )),
        i
    }
    function be(e) {
        return new Promise((t=>{
            !e || "IMG" !== e.tagName || e.complete ? t() : e.onload = ()=>t()
        }
        ))
    }
    var ge = class {
        constructor(e) {
            this._effect = e,
            this._playState = "idle",
            this._finished = Promise.resolve()
        }
        get finished() {
            return this._finished
        }
        get animationEffects() {
            return this._effect instanceof fe ? [this._effect] : this._effect.animationEffects
        }
        cancel() {
            this.animationEffects.forEach((e=>e.cancel()))
        }
        finish() {
            this.animationEffects.forEach((e=>e.finish()))
        }
        play() {
            this._playState = "running",
            this._effect.play(),
            this._finished = this._effect.finished,
            this._finished.then((()=>{
                this._playState = "finished"
            }
            ), (e=>{
                this._playState = "idle"
            }
            ))
        }
    }
      , fe = class {
        constructor(e, t, i={}) {
            e && ("Animation"in window ? this._animation = new Animation(new KeyframeEffect(e,t,i)) : (i.fill = "forwards",
            this._animation = e.animate(t, i),
            this._animation.pause()),
            this._animation.addEventListener("finish", (()=>{
                e.style.opacity = t.hasOwnProperty("opacity") ? t.opacity[t.opacity.length - 1] : null,
                e.style.visibility = t.hasOwnProperty("visibility") ? t.visibility[t.visibility.length - 1] : null
            }
            )))
        }
        get finished() {
            return this._animation ? this._animation.finished ? this._animation.finished : new Promise((e=>this._animation.onfinish = e)) : Promise.resolve()
        }
        play() {
            this._animation && (this._animation.startTime = null,
            this._animation.play())
        }
        cancel() {
            this._animation && this._animation.cancel()
        }
        finish() {
            this._animation && this._animation.finish()
        }
    }
      , we = class {
        constructor(e) {
            this._childrenEffects = e,
            this._finished = Promise.resolve()
        }
        get finished() {
            return this._finished
        }
        get animationEffects() {
            return this._childrenEffects.flatMap((e=>e instanceof fe ? e : e.animationEffects))
        }
    }
      , ye = class extends we {
        play() {
            const e = [];
            for (const t of this._childrenEffects)
                t.play(),
                e.push(t.finished);
            this._finished = Promise.all(e)
        }
    }
      , ve = class extends we {
        play() {
            this._finished = new Promise((async(e,t)=>{
                try {
                    for (const e of this._childrenEffects)
                        e.play(),
                        await e.finished;
                    e()
                } catch (e) {
                    t()
                }
            }
            ))
        }
    }
      , _e = class extends HTMLElement {
        async connectedCallback() {
            this._pendingAnimations = [],
            this.addEventListener("split-lines:re-split", (e=>{
                Array.from(e.target.children).forEach((e=>e.style.visibility = this.selected ? "visible" : "hidden"))
            }
            )),
            ne.prefersReducedMotion() && (this.setAttribute("reveal-visibility", ""),
            Array.from(this.querySelectorAll("[reveal], [reveal-visibility]")).forEach((e=>{
                e.removeAttribute("reveal"),
                e.removeAttribute("reveal-visibility")
            }
            )))
        }
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        async transitionToLeave(e, t=!0) {
            "reveal" !== e && this.setAttribute("hidden", ""),
            this._pendingAnimations.forEach((e=>e.cancel())),
            this._pendingAnimations = [];
            let i = null
              , n = await ae(this.querySelectorAll("split-lines, .button-group, .button-wrapper"))
              , s = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
            switch (e) {
            case "sweep":
                i = new ge(new ve([new fe(this,{
                    visibility: ["visible", "hidden"]
                },{
                    duration: 500
                }), new ye(n.map((e=>new fe(e,{
                    opacity: [1, 0],
                    visibility: ["visible", "hidden"]
                }))))]));
                break;
            case "fade":
                i = new ge(new fe(this,{
                    opacity: [1, 0],
                    visibility: ["visible", "hidden"]
                },{
                    duration: 250,
                    easing: "ease-in-out"
                }));
                break;
            case "reveal":
                i = new ge(new ve([new ye(n.reverse().map((e=>new fe(e,{
                    opacity: [1, 0],
                    visibility: ["visible", "hidden"]
                },{
                    duration: 250,
                    easing: "ease-in-out"
                })))), new ye(s.map((e=>e.classList.contains("slideshow__image-wrapper--secondary") ? new fe(e,{
                    visibility: ["visible", "hidden"],
                    clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"]
                },{
                    duration: 450,
                    easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)"
                }) : new fe(e,{
                    visibility: ["visible", "hidden"],
                    clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"]
                },{
                    duration: 450,
                    easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)"
                }))))]))
            }
            await this._executeAnimation(i, t),
            "reveal" === e && this.setAttribute("hidden", "")
        }
        async transitionToEnter(e, t=!0, i=!1) {
            this.removeAttribute("hidden"),
            await this._untilReady();
            let n = null
              , s = await ae(this.querySelectorAll("split-lines, .button-group, .button-wrapper"))
              , a = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
            switch (e) {
            case "sweep":
                n = new ge(new ve([new fe(this,{
                    visibility: ["hidden", "visible"],
                    clipPath: i ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"] : ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
                },{
                    duration: 500,
                    easing: "cubic-bezier(1, 0, 0, 1)"
                }), new ye(s.map(((e,t)=>new fe(e,{
                    opacity: [0, 1],
                    visibility: ["hidden", "visible"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                    transform: ["translateY(100%)", "translateY(0)"]
                },{
                    duration: 450,
                    delay: 100 * t,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                }))))]));
                break;
            case "fade":
                n = new ge(new fe(this,{
                    opacity: [0, 1],
                    visibility: ["hidden", "visible"]
                },{
                    duration: 250,
                    easing: "ease-in-out"
                }));
                break;
            case "reveal":
                n = new ge(new ve([new ye(a.map((e=>e.classList.contains("slideshow__image-wrapper--secondary") ? new fe(e,{
                    visibility: ["hidden", "visible"],
                    clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"]
                },{
                    duration: 450,
                    delay: 100,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                }) : new fe(e,{
                    visibility: ["hidden", "visible"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
                },{
                    duration: 450,
                    delay: 100,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                })))), new ye(s.map(((e,t)=>new fe(e,{
                    opacity: [0, 1],
                    visibility: ["hidden", "visible"],
                    clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"],
                    transform: ["translateY(100%)", "translateY(0)"]
                },{
                    duration: 450,
                    delay: 100 * t,
                    easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
                }))))]))
            }
            return this._executeAnimation(n, t)
        }
        async _executeAnimation(e, t) {
            return this._pendingAnimations.push(e),
            t ? e.play() : e.finish(),
            e.finished
        }
        async _untilReady() {
            return Promise.all(this._getVisibleImages().map((e=>be(e))))
        }
        _preloadImages() {
            this._getVisibleImages().forEach((e=>{
                e.setAttribute("loading", "eager")
            }
            ))
        }
        _getVisibleImages() {
            return Array.from(this.querySelectorAll("img")).filter((e=>"none" !== getComputedStyle(e.parentElement).display))
        }
    }
    ;
    // window.customElements.define("slide-show-item", _e);
    var Se = class extends HTMLElement {
        get index() {
            return [...this.parentNode.children].indexOf(this)
        }
        get selected() {
            return !this.hasAttribute("hidden")
        }
        get hasAttachedImage() {
            return this.hasAttribute("attached-image")
        }
        async transitionToEnter(e=!0) {
            this.removeAttribute("hidden");
            const t = this.querySelector(".image-with-text__text-wrapper")
              , i = await ae(this.querySelectorAll(".image-with-text__content split-lines"))
              , n = new ge(new ve([new ye(i.map(((e,t)=>new fe(e,{
                opacity: [0, .2, 1],
                transform: ["translateY(100%)", "translateY(0)"],
                clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"]
            },{
                duration: 350,
                delay: 120 * t,
                easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)"
            })))), new fe(t,{
                opacity: [0, 1]
            },{
                duration: 300
            })]));
            return e ? n.play() : n.finish(),
            n.finished
        }
        async transitionToLeave(e=!0) {
            const t = await ae(this.querySelectorAll(".image-with-text__text-wrapper, .image-with-text__content split-lines"))
              , i = new ge(new ye(t.map((e=>new fe(e,{
                opacity: [1, 0]
            },{
                duration: 200
            })))));
            e ? i.play() : i.finish(),
            await i.finished,
            this.setAttribute("hidden", "")
        }
    }
    ;
    window.customElements.define("image-with-text-item", Se);
    window.customElements.define("image-with-text", class extends d {
        connectedCallback() {
            this.items = Array.from(this.querySelectorAll("image-with-text-item:not(.hc-heading)")),
            this.headingItems = Array.from(this.querySelectorAll("image-with-text-item.hc-heading")),
            this.imageItems = Array.from(this.querySelectorAll(".image-with-text__image")),
            this.pageDots = this.querySelector("page-dots"),
            this.hasPendingTransition = !1,
            this.items.length > 1 && (this.addEventListener("page-dots:changed", (e=>this.select(e.detail.index))),
            Shopify.designMode && (this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this)),
            this.addEventListener("shopify:block:select", (e=>{
                this.intersectionObserver.disconnect(),
                this.pausePlayer(),
                this.select(e.target.index, !e.detail.load)
            }
            )))),
            this._setupVisibility()
        }
        async _setupVisibility() {
            await this.untilVisible(),
            this.hasAttribute("reveal-on-scroll") && (await this.transitionImage(this.selectedIndex),
            this.select(this.selectedIndex)),
            this.startPlayer()
        }
        get selectedIndex() {
            return this.items.findIndex((e=>e.selected))
        }
        async select(e, t=!0) {
            if (!this.hasPendingTransition) {
                if (this.hasPendingTransition = !0,
                !this.items[e].hasAttachedImage && t || await this.transitionImage(e, t),
                this.selectedIndex !== e) {
                    const e = this.selectedIndex;
                    this.headingItems.length > 0 && this.headingItems[e].transitionToLeave(t),
                    await this.items[e].transitionToLeave(t)
                }
                this.pageDots && (this.pageDots.selectedIndex = e),
                this.headingItems.length > 0 && this.headingItems[e].transitionToEnter(t),
                await this.items[e].transitionToEnter(t),
                this.hasPendingTransition = !1
            }
        }
        async transitionImage(e, t=!0) {
            const i = this.imageItems.find((e=>!e.hasAttribute("hidden")))
              , n = this.imageItems.find((t=>t.id === this.items[e].getAttribute("attached-image"))) || i;
            i.setAttribute("hidden", ""),
            n.removeAttribute("hidden"),
            await be(n);
            const s = new ge(new fe(n,{
                visibility: ["hidden", "visible"],
                clipPath: ["inset(0 0 0 100%)", "inset(0 0 0 0)"]
            },{
                duration: 600,
                easing: "cubic-bezier(1, 0, 0, 1)"
            }));
            t ? s.play() : s.finish()
        }
        pausePlayer() {
            this.style.setProperty("--section-animation-play-state", "paused")
        }
        startPlayer() {
            this.style.setProperty("--section-animation-play-state", "running")
        }
    }
    );

})();
